import { z } from 'zod';

// FIXME: figure out how/where enums should live

export enum QuoteItemAmendmentStatusEnum {
  ADDED = 'ADDED',
  NO_CHANGE = 'NO_CHANGE',
  REMOVED = 'REMOVED',
  UPDATED = 'UPDATED',
}

export enum ContactStatusEnum {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
}

export enum QuoteStatusEnum {
  DRAFT = 'DRAFT',
  REVIEW = 'REVIEW',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  SENT = 'SENT',
  ACCEPTED = 'ACCEPTED',
  ACCEPTED_ADMIN_EDITABLE = 'ACCEPTED_ADMIN_EDITABLE',
  PROCESSED = 'PROCESSED',
  CANCELED = 'CANCELED',
  EXPIRED = 'EXPIRED',
  ARCHIVED = 'ARCHIVED',
}

// Quote statuses that have an API endpoint to transition to them
export type QuoteStatusTransitions =
  | QuoteStatusEnum.DRAFT
  | QuoteStatusEnum.REVIEW
  | QuoteStatusEnum.SENT
  | QuoteStatusEnum.ACCEPTED;

export enum QuoteTypeEnum {
  NEW = 'NEW',
  AMENDMENT = 'AMENDMENT',
  RENEWAL = 'RENEWAL',
}
export enum QuoteCancelationReasonEnum {
  EXPIRED = 'EXPIRED',
  CUSTOMER_DECLINED = 'CUSTOMER_DECLINED',
  DUPLICATE = 'DUPLICATE',
  BY_USER = 'BY_USER',
  SUPERSEDED_BY_PROCESSED_QUOTE = 'SUPERSEDED_BY_PROCESSED_QUOTE',
  BY_MIGRATION = 'BY_MIGRATION',
}

export enum NewQuoteTypeEnum {
  NET_NEW = 'NET_NEW',
  MANUAL_RENEWAL = 'MANUAL_RENEWAL',
  EARLY_RENEWAL = 'EARLY_RENEWAL',
}

export enum CollaborationAccessEnum {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  NONE = 'NONE',
}
export const COLLABORATION_ACCESS_DISPLAY: {
  [key in CollaborationAccessEnum]: string;
} = {
  VIEW: 'View Only',
  EDIT: 'Edit',
  NONE: 'No Access',
};

export enum CollaborationAccessLevelEnum {
  WRITE = 'WRITE',
  READ = 'READ',
}

export enum SigningOrderEnum {
  INTERNAL_FIRST = 'INTERNAL_FIRST',
  EXTERNAL_FIRST = 'EXTERNAL_FIRST',
  EXTERNAL_ONLY = 'EXTERNAL_ONLY',
  INSTANTANEOUS = 'INSTANTANEOUS',
}

export enum OpportunityStatusEnum {
  WON = 'WON',
  CANCELED = 'CANCELED',
  ACTIVE = 'ACTIVE',
  LOST = 'LOST',
}

export enum NetTermsEnum {
  NET_0 = 'NET_0',
  NET_5 = 'NET_5',
  NET_7 = 'NET_7',
  NET_8 = 'NET_8',
  NET_10 = 'NET_10',
  NET_14 = 'NET_14',
  NET_15 = 'NET_15',
  NET_20 = 'NET_20',
  NET_21 = 'NET_21',
  NET_30 = 'NET_30',
  NET_45 = 'NET_45',
  NET_60 = 'NET_60',
  NET_75 = 'NET_75',
  NET_90 = 'NET_90',
  NET_100 = 'NET_100',
  NET_120 = 'NET_120',
  NET_150 = 'NET_150',
  NET_180 = 'NET_180',
}

export enum ApprovalStatusEnum {
  NO_ACTION = 'NO_ACTION',
  DECLINED = 'DECLINED',
  APPROVED = 'APPROVED',
}

export enum AmountUnitTypeEnum {
  FLAT = 'FLAT',
  PERCENTAGE = 'PERCENTAGE',
}

export enum DiscountStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
}

export enum DiscountLifeCyclePolicyEnum {
  EXCLUDE_FROM_RENEWAL = 'EXCLUDE_FROM_RENEWAL',
}

export enum DiscountDurationEnum {
  LIMITED = 'LIMITED',
  UNLIMITED = 'UNLIMITED',
  ONE_TIME = 'ONE_TIME',
}

export enum DiscountApplicationMethodEnum {
  COMBINED = 'COMBINED',
  SEQUENTIAL = 'SEQUENTIAL',
}

export enum DiscountCategoryEnum {
  CATALOG = 'CATALOG',
  CUSTOM = 'CUSTOM_QUOTE_DISCOUNT',
}

export enum ProductTypeEnum {
  // ARREARS exists on the BE, but is not used in the FE: you cannot create an ARREARS product (but you can make a rate's subscription timing = ARREARS)
  ADVANCE = 'ADVANCE',
  // SUBSCRIPTION = 'SUBSCRIPTION',   // will eventually replace ADVANCE
  USAGE = 'USAGE',
  ONETIME = 'ONETIME',
  MIN_COMMIT = 'MIN_COMMIT',
  ONETIME_PREPAID_CREDIT = 'ONETIME_PREPAID_CREDIT',
  RECURRING_TOKEN = 'RECURRING_TOKEN',
  ONETIME_TOKEN = 'ONETIME_TOKEN',
  DISCOUNT = 'DISCOUNT',
}

export enum OfferingStatusEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  CANCELED = 'CANCELED',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
  ARCHIVED = 'ARCHIVED',
}

export enum OfferingTypesEnum {
  SUBSCRIPTION = 'SUBSCRIPTION',
  ONETIME = 'ONETIME',
  MIN_COMMIT = 'MIN_COMMIT',
  CUSTOM_PERCENT_OF_TOTAL = 'CUSTOM_PERCENT_OF_TOTAL',
  TOKEN = 'TOKEN',
  ONETIME_TOKEN = 'ONETIME_TOKEN',
}

export enum PriceModelEnum {
  VOLUME = 'VOLUME',
  TIERED = 'TIERED',
  FLAT = 'FLAT',
  CUSTOM = 'CUSTOM',
  PERCENT_OF_TOTAL = 'PERCENT_OF_TOTAL',
  BLOCK = 'BLOCK',
}

export enum ContractEndActionEnum {
  RENEW = 'RENEW',
  MANUAL_RENEW = 'MANUAL_RENEW',
  CANCEL = 'CANCEL',
}

export enum RenewalTermLengthEnum {
  ContractLength = 'ContractLength',
  FixedMonths = 'FixedMonths',
}

export enum QuoteSettingsDefaultAddressSourceEnum {
  CONTACT = 'CONTACT',
  ACCOUNT = 'ACCOUNT',
}

export enum AutoPaymentCollectionTimingEnum {
  INVOICE_GENERATION = 'INVOICE_GENERATION',
  INVOICE_SEND = 'INVOICE_SEND',
}

export enum StorageTypeEnum {
  MSA = 'MSA',
  SOW = 'SOW',
  COVER = 'COVER',
  FOOTER = 'FOOTER',
  ATTACHMENT = 'ATTACHMENT',
  DPA = 'DPA',
  NPA = 'NPA',
  NDA = 'NDA',
  LOGO = 'LOGO',
  ESIGN = 'ESIGN',
  DOCUMENT_DEFINITION = 'DOCUMENT_DEFINITION',
}
export const StorageTypeEnumZ = z.enum(StorageTypeEnum);

export enum StorageReferenceTypeEnum {
  QUOTE = 'QUOTE',
  QUOTE_CONFIG = 'QUOTE_CONFIG',

  RESOURCE_REFERENCE = 'RESOURCE_REFERENCE',
  DEAL_ROOM = 'DEAL_ROOM',
  COMPANY_CONFIG = 'COMPANY_CONFIG',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
  ACCOUNT_DOCUMENT = 'ACCOUNT_DOCUMENT',
}

export enum RateBillingFrequencyEnum {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEMIANNUALLY = 'SEMIANNUALLY',
  ANNUALLY = 'ANNUALLY',
  CUSTOM = 'CUSTOM',
  ONETIME = 'ONETIME',
}

export const ContactStatusEnumZ = z.enum(ContactStatusEnum);
export const QuoteItemAmendmentStatusEnumZ = z.enum(
  QuoteItemAmendmentStatusEnum,
);
export const QuoteStatusEnumZ = z.enum(QuoteStatusEnum);
export const QuoteTypeEnumZ = z.enum(QuoteTypeEnum);
export const QuoteCancelationReasonEnumZ = z.enum(QuoteCancelationReasonEnum);
export const NewQuoteTypeEnumZ = z.enum(NewQuoteTypeEnum);
export const CollaborationAccessEnumZ = z.enum(CollaborationAccessEnum);
export const CollaborationAccessLevelEnumZ = z.enum(
  CollaborationAccessLevelEnum,
);
export const SigningOrderEnumZ = z.enum(SigningOrderEnum);
export const OpportunityStatusEnumZ = z.enum(OpportunityStatusEnum);
export const NetTermsEnumZ = z.enum(NetTermsEnum);
export const ApprovalStatusEnumZ = z.enum(ApprovalStatusEnum);
export const DiscountTypeEnumZ = z.enum(AmountUnitTypeEnum);
export const DiscountStatusEnumZ = z.enum(DiscountStatusEnum);
export const DiscountDurationEnumZ = z.enum(DiscountDurationEnum);
export const DiscountApplicationMethodEnumZ = z.enum(
  DiscountApplicationMethodEnum,
);
export const DiscountCategoryEnumZ = z.enum(DiscountCategoryEnum);
export const ProductTypeEnumZ = z.enum(ProductTypeEnum);
export const OfferingStatusEnumZ = z.enum(OfferingStatusEnum);
export const ContractEndActionEnumZ = z.enum(ContractEndActionEnum);
export const RenewalTermLengthEnumZ = z.enum(RenewalTermLengthEnum);
export const QuoteSettingsDefaultAddressSourceEnumZ = z.enum(
  QuoteSettingsDefaultAddressSourceEnum,
);
export const StorageReferenceTypeEnumZ = z.enum(StorageReferenceTypeEnum);
export const RateBillingFrequencyEnumZ = z.enum(RateBillingFrequencyEnum);
export const DiscountLifeCyclePolicyEnumZ = z.enum([
  DiscountLifeCyclePolicyEnum.EXCLUDE_FROM_RENEWAL,
]);
export enum ToggleState {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum TenantStatusEnum {
  ACTIVE = 'ACTIVE',
  INVITED = 'INVITED',
}

export const TENANT_STATUS_DISPLAY: {
  [key in TenantStatusEnum]: string;
} = {
  ACTIVE: 'Active',
  INVITED: 'Invited',
};
